import 'lazysizes';
import { navigation } from '../components/navigation';
import { scrollNavigation } from '../components/scrollNavigation';
import { setGlobalState } from '../util/helpers';
import { mq } from '../util/matchMedia';

export default {
  init() {
    mq.init();
    // Prevent browser from remembering user's scroll position
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    setGlobalState('hidePreloader', true);
  },

  finalize() {
    scrollNavigation.init();
    navigation.highlightActiveLink();
  },
};
